export default __webpack_public_path__ + "static/media/expl_gradcam_11_DE.1d81389a.png";